import { loc_equal } from 'shared/map/lib/utils';
import * as L from 'leaflet';
import { getDeviceModelProps } from '../model';
import * as classnames from 'classnames';
import 'entities/device.map.markers/model/iconwithlabel.sass';
import * as lodash from 'lodash';
import { useLeafletContext } from '@react-leaflet/core';
import { useEffect, useRef } from 'react';
const _DeviceModelIcon = L.Icon.extend({
    options: {
        iconSize: [72, 80],
        iconAnchor: [72 / 2, 40],
        opacity: 1,
        label_visible: true,
        label_top: 50,
    },
    initialize(options) {
        L.Util.setOptions(this, options);
        this.div = document.createElement('div');
        this.div.style.position = 'absolute';
        this.div.className = options.className;
        this.label = document.createElement('span');
        this.label.className = 'device-icon-label';
        this.div.appendChild(this.label);
    },
    createShadow() {
        return null;
    },
    createIcon() {
        this.div.style.width = `${this.options.iconSize[0]}px`;
        this.div.style.height = `${this.options.iconSize[1]}px`;
        this.div.style.marginLeft = `${-this.options.iconSize[0] / 2}px`;
        this.div.style.marginTop = `${-this.options.iconSize[1] / 2}px`;
        this.div.style.opacity = this.options.opacity;
        this.label.textContent = this.options.label;
        this.label.style.top = this.options.label_top + '%';
        this.label.className = classnames('device-icon-label', {
            offline: !this.options.online,
            has_errors: this.options.errors != null,
            'device-icon-label-visible': this.options.label_visible,
        });
        this.label.title =
            !this.options.online && this.options.errors == null
                ? 'Не на связи'
                : this.options.errors != null
                    ? this.options.errors.toString().replace(/,/g, '\n')
                    : '';
        return this.div;
    },
});
const DeviceModelIcon = _DeviceModelIcon.addInitHook(() => { });
function createIconMarker(context, props) {
    const { dev_loc, errors } = props;
    const { name, dev_type, online } = dev_loc;
    return new DeviceModelIcon({
        label: name,
        online,
        errors,
        ...getDeviceModelProps(dev_type),
    });
}
function updateComplexMarker(context, instance, props, prevProps) {
    if (prevProps.errors !== props.errors ||
        !lodash.isEqual(prevProps.dev_loc, props.dev_loc)) {
        instance.setIcon(createIconMarker(context, prevProps));
    }
    if (!loc_equal(prevProps.position, props.position))
        instance.setLatLng(props.position);
}
export const DeviceModelMarker = (props) => {
    const context = useLeafletContext();
    const elementRef = useRef();
    const propsRef = useRef(props);
    useEffect(() => {
        const icon = createIconMarker(context, props);
        const marker = L.marker(props.position, {
            zIndexOffset: props.zIndexOffset != null ? props.zIndexOffset : 0,
            ...props,
        });
        marker.on('click', (e) => props.onClick?.(e));
        marker.setIcon(icon);
        elementRef.current = marker;
        const container = context.layerContainer || context.map;
        container.addLayer(elementRef.current);
        return () => {
            if (elementRef.current)
                container.removeLayer(elementRef.current);
        };
    }, []);
    useEffect(() => {
        const container = context.layerContainer || context.map;
        if (elementRef.current) {
            updateComplexMarker(context, elementRef.current, props, propsRef.current);
            container.addLayer(elementRef.current);
        }
        return () => {
            if (elementRef.current)
                container.removeLayer(elementRef.current);
        };
    }, [props]);
    return null;
};
